// Modelos del agente. Centralizado para que el Director (VideoEditor), el
// Asistente (useV2Chat) y la edge function `chat-agent` usen los mismos IDs.
//
// El edge function valida el `model` recibido contra una allow-list y aplica
// el pricing correcto por modelo (Opus es bastante más caro que Sonnet).

export const MODEL_SONNET = 'claude-sonnet-4-6';
export const MODEL_OPUS = 'claude-opus-4-8';

// Nivel de "inteligencia" que elige el usuario en el Asistente.
//   baja  → Sonnet (igual que media; opción "señuelo").
//   media → Sonnet (default, recomendada).
//   alta  → Opus (más potente, consume más créditos).
export type Intelligence = 'baja' | 'media' | 'alta';

export const intelligenceToModel = (lvl: Intelligence): string =>
  lvl === 'alta' ? MODEL_OPUS : MODEL_SONNET;

export const INTELLIGENCE_LABEL: Record<Intelligence, string> = {
  baja: 'Baja',
  media: 'Media',
  alta: 'Alta',
};

// Créditos mínimos que el usuario debe tener para iniciar un turno con cada
// modelo. Es conservador: un turno con Opus puede costar varios créditos
// (sobre todo el que cambia de modelo, que paga la creación del cache a la
// tarifa de Opus). No arrancamos un request que el saldo no podría cubrir.
export const minCreditsForModel = (model: string): number =>
  model === MODEL_OPUS ? 6 : 1;
